import React from "react";

import RobotNavigation from "../features/robot/RobotNavigation";
import RobotSummary from "../features/robot/RobotSummary";

function SummaryPage(props) {
  return (
    <>
      <RobotNavigation {...props} />
      <RobotSummary {...props} />
    </>
  );
}

export default SummaryPage;
